<template>
<footer>
  <div class="qbk-wrap">
    <div class="qbk-foot-top">
      <div class="row">
        <div class="col-12 col-md-4 qbk-ft-item pb-5">
          <img src="../assets/images/logo.svg" alt="">
          <p>When staying at a hotel, the design and architecture are two important factors that can spoil your eyes. With its unique setting, Qubika Boutique Hotel provides a pleasant accommodation for your stay.</p>
          <div class="qbk-ft-sosmed">
            <a target="_blank" href="https://www.facebook.com/qubikahotel/?ref=br_rs">
              <img src="../assets/images/fb.svg" alt="">
            </a>
            <a target="_blank" href="https://www.instagram.com/qubikahotelserpong/">
              <img src="../assets/images/ig.svg" alt="">
            </a>
          </div>
        </div>
        <div class="col-12 col-md-4 qbk-ft-item pb-5">
          <h4>Contact</h4>
          <ul>
            <li>
              <div><img src="../assets/images/map-pointer.svg" alt=""></div>
              <span>Jl. Boulevard Raya Gading Serpong No.9 - 10, Medang, Kec. Klp. Dua, Tangerang, Banten 15334</span>
            </li>
            <li>
              <div><img src="../assets/images/phone.svg" alt=""></div>
              <span>021 2297 0888</span>
            </li>
            <li>
              <div><img src="../assets/images/mobile.svg" alt=""></div>
              <span>0822 4645 7423</span>
            </li>
            <li>
              <div><img src="../assets/images/envelope.svg" alt=""></div>
              <router-link to="mailto:reservation@qubikahotel.com">reservation@qubikahotel.com</router-link>
            </li>
          </ul>
        </div>
        <div class="col-12 col-md-4 qbk-ft-item">
          <h4>Newsletter</h4>
          <p>Suscribe now and get special deals from us!</p>
          <input type="text" v-model="form.data.content">
          <button type="button" @click="doSubscribe()">Subscribe</button>
        </div>
      </div>
    </div>
    <div class="qbk-foot-bot d-md-flex d-block">
      <p>&copy; 2020 Qubika Hotel. All Rights Reserved</p>
      <ul>
        <li>
          <router-link to="/home">Home</router-link>
        </li>
        <li>
          <router-link to="https://www.e1-booking.com/booking/booking-page.php?id=1526">Booking</router-link>
        </li>
        <li>
          <router-link to="/contact-us">Contact Us</router-link>
        </li>
      </ul>
    </div>
  </div>
</footer>
</template>

<script>
import axios from 'axios'
import {
  baseUrl
} from '../config'
export default {
  data() {
    return {
      subscribe: null,
      form: {
        loading: false,
        data: {
          id: null,
          image: null,
          title: 'SUBSCRIBE ITEM',
          content: null,
          id_parent: null,
          type: 'SUBSCRIBE ITEM',
        },
        deleteId: null
      },
    }
  },
  methods: {
    doSubscribe() {
      this.form.loading = true
      if (!this.validateEmail(this.form.data.content)) {
        this.form.loading = false
        this.notif('Warning', 'Please input valid email', 'warning')
      } else {
        let url = baseUrl + '/api/post/create'
        if (this.form.data.id)
          url = baseUrl + '/api/post/update'
        axios.post(url, this.form.data)
          .then(res => {
            if (res.data.status) {
              this.notif('Success', 'Thank you for subscribe', 'success')
              this.clearForm()
            } else {
              this.notif('Failed', 'Subscribe failed please try again', 'danger')
            }
            this.form.loading = false
          })
          .catch(() => {
            this.form.loading = false
            this.notif('Failed', 'Save:Internal server error', 'danger')
          });
      }
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    clearForm() {
      this.form = {
        loading: false,
        data: {
          id: null,
          image: null,
          title: 'SUBSCRIBE ITEM',
          content: null,
          id_parent: null,
          type: 'SUBSCRIBE ITEM',
        },
        deleteId: null
      }
    },
    notif(title, msg, type) {
      this.$bvToast.toast(msg, {
        title: title,
        autoHideDelay: 5000,
        variant: type,
        solid: true,
        toaster: 'b-toaster-bottom-left'
      })
    },
  }
}
</script>
